import { render, staticRenderFns } from "./TransactionView.vue?vue&type=template&id=e7278394&scoped=true&"
import script from "./TransactionView.vue?vue&type=script&lang=js&"
export * from "./TransactionView.vue?vue&type=script&lang=js&"
import style0 from "./TransactionView.vue?vue&type=style&index=0&id=e7278394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7278394",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7278394')) {
      api.createRecord('e7278394', component.options)
    } else {
      api.reload('e7278394', component.options)
    }
    module.hot.accept("./TransactionView.vue?vue&type=template&id=e7278394&scoped=true&", function () {
      api.rerender('e7278394', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory/transactions/TransactionView.vue"
export default component.exports